import { createContext } from "react";

export const AppContext = createContext({
    id: null,
    currentUser: null,
    setCurrentUser: (x) => { },
    permissions: null,
    setPermissions: (x) => { },
    product: null,
    setProduct: (x) => { },
    products: null,
    setProducts: (x) => { },
    contexts: null,
    setContexts: (x) => { },
    theme: null,
    setTheme: (x) => { },
    favoriteThemes: null,
    setFavoriteThemes: (x) => { },
    superAdmin: null,
    setSuperAdmin: (x) => { },
    institutionBranch: null,
    setInstitutionBranch: (x) => { },
    profile: null,
    setProfile: (x) => { },
    schoolStudentTutorialCompletion: null,
    setSchoolStudentTutorialCompletion: (x) => { },
    schoolManagerTutorialCompletion: null,
    setSchoolManagerTutorialCompletion: (x) => { },
    officeStudentTutorialCompletion: null,
    setOfficeStudentTutorialCompletion: (x) => { },
    officeManagerTutorialCompletion: null,
    setOfficeManagerTutorialCompletion: (x) => { },
    setContext: () => { },
    clearContext: () => { }
})